import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {},
  questionnaireStepper: 0,
};

const patientDataSlice = createSlice({
  name: 'patientData',
  initialState,
  reducers: {
    setPatientData: (state, action) => {
      state.data = action.payload;
    },
    updatePatientField: (state, action) => {
      const { key, value } = action.payload;
      state.data[key] = value;
    },
    setQuestionnaireStepper: (state, action) => {
      state.questionnaireStepper = action.payload;
    },
    clearPatientData: (state) => {
      state.data = {};
      state.questionnaireStepper = 0;
    },
  },
});

export const { setPatientData, updatePatientField, setQuestionnaireStepper, clearPatientData } =
  patientDataSlice.actions;

export default patientDataSlice.reducer;
